/* MAYLUCK navigation and search, using the retained demo presentation. */
(() => {
  const mlIsDe = /^de(?:-|$)/i.test(document.documentElement.lang || '');
  const qs = (selector, scope = document) => scope?.querySelector(selector);
  let lastSearchFocus;
  function setMenu(open) {
    const menu = qs('#ml-mobile-nav'), button = qs('[data-mobile-toggle]');
    if (menu) menu.hidden = !open;
    if (button) {
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? window.MLI18n.t('s_6ccd5c785604_html') : window.MLI18n.t('s_b40b3713b43d_html'));
      qs('[data-mobile-open-icon]', button)?.toggleAttribute('hidden', open);
      qs('[data-mobile-close-icon]', button)?.toggleAttribute('hidden', !open);
    }
  }
  function closeShop() {
    const menu = qs('#ml-shop-menu');
    if (menu) menu.hidden = true;
    qs('[data-shop-toggle]')?.setAttribute('aria-expanded', 'false');
  }
  function filterSearch() {
    const dialog = qs('#ml-search-dialog'), query = qs('[data-search-input]', dialog)?.value || '';
    let count = 0;
    dialog?.querySelectorAll('[data-search-result]').forEach(link => {
      link.hidden = !(link.dataset.searchText || '').toLowerCase().includes(query.toLowerCase());
      if (!link.hidden) count += 1;
    });
    const heading = qs('[data-search-heading]', dialog), empty = qs('[data-search-empty]', dialog);
    if (heading) heading.textContent = query ? window.MLI18n.t('s_347964d5dc26_html') : window.MLI18n.t('s_9cc1813f955e_html');
    if (empty) empty.hidden = count > 0;
  }
  function initialize() {
    const shop = qs('.nav-shop'), dialog = qs('#ml-search-dialog');
    if (shop && !shop.dataset.mlNavigationReady) {
      shop.dataset.mlNavigationReady = 'true';
      shop.addEventListener('mouseleave', closeShop);
    }
    if (dialog && !dialog.dataset.mlNavigationReady) {
      dialog.dataset.mlNavigationReady = 'true';
      dialog.addEventListener('close', () => { if (lastSearchFocus?.isConnected) lastSearchFocus.focus({ preventScroll: true }); });
    }
    filterSearch();
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const mobile = event.target.closest('[data-mobile-toggle]');
    if (mobile) { setMenu(qs('#ml-mobile-nav')?.hidden); return; }
    const shop = event.target.closest('[data-shop-toggle]');
    if (shop) { const menu = qs('#ml-shop-menu'); if (menu) { menu.hidden = !menu.hidden; shop.setAttribute('aria-expanded', String(!menu.hidden)); } return; }
    if (!event.target.closest('.nav-shop')) closeShop();
    const search = event.target.closest('[data-search-open],.site-header button[aria-label*="earch"]');
    if (search) { lastSearchFocus = search; const dialog = qs('#ml-search-dialog'); if (dialog && !dialog.open) dialog.showModal(); qs('[data-search-input]', dialog)?.focus(); return; }
    if (event.target.closest('[data-search-close]') || event.target === qs('#ml-search-dialog')) qs('#ml-search-dialog')?.close();
    if (event.target.closest('#ml-mobile-nav a')) setMenu(false);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeShop(); setMenu(false); } });
  document.addEventListener('input', event => { if (event.target.matches('[data-search-input]')) filterSearch(); });
  document.addEventListener('shopify:section:load', () => { initialize(); closeShop(); setMenu(false); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
